module.exports = __webpack_public_path__ + "media/bootstrap-icons/hdd-rack-fill-0f85fba0.svg";